import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { Packager } from '../../../types/packager-types';

type IusePackagerSimulateProps = {
  dataPoolId: string;
  packagerId: string;
  data: Packager;
};

export const usePackagerSimulate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IusePackagerSimulateProps) => {
      return await (await glynt).packager.simulate(data.dataPoolId, data.packagerId, data.data);
    },

    ...callbacks
  });
};
